import React from "react";
import { Avatar, ListItem, ListItemAvatar, ListItemText } from "@material-ui/core";
import ErrorOutlineRoundedIcon from '@material-ui/icons/ErrorOutlineRounded';


export const EmptyListItem = () => {
    return (
        <ListItem
            key={`key-for-empty-row`}>
            <ListItemAvatar>
                <Avatar>
                    <ErrorOutlineRoundedIcon />
                </Avatar>
            </ListItemAvatar>
            <ListItemText
                primary="Brak wyników wyszukiwania w bazie Rock Gawędy"
            />
        </ListItem>
    );
};
